<div class="surface-card shadow-2 border-round p-4">
    @if(type() === 'formulation-types') {
        <div class="flex align-items-center justify-content-between mb-3">
            <div class="flex align-items-center gap-2">
                <span class="text-900 font-bold text-lg">Tipos de Formulación</span>
                <p-button
                    icon="pi pi-info-circle"
                    [rounded]="true"
                    [text]="true"
                    severity="info"
                    pTooltip="¿Qué es un Tipo de Formulación?"
                    (onClick)="formulationInfoOp.toggle($event)"
                    styleClass="p-button-sm">
                </p-button>
            </div>
        </div>

        <p-popover #formulationInfoOp styleClass="formulation-info-popover" [style]="{'max-width': '520px'}">
            <div class="p-4 flex flex-column gap-4">
                <div class="flex align-items-center gap-3 border-bottom-1 border-100 pb-3">
                    <div style="width:40px;height:40px;border-radius:10px;background:linear-gradient(135deg,#3b82f6,#1e40af);display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                        <i class="pi pi-info-circle" style="color:white;font-size:1.2rem;"></i>
                    </div>
                    <div>
                        <h3 class="m-0 text-900 font-bold">Tipos de Formulación</h3>
                        <p class="m-0 text-500 text-sm">Guía de campos y su propósito</p>
                    </div>
                </div>

                <p class="m-0 text-600 text-sm line-height-3">
                    Los <b>Tipos de Formulación</b> representan las formas en que se presenta un agroquímico o sustancia activa. Cada tipo tiene características que impactan directamente en la generación automática de códigos de los ítems de ensayo.
                </p>

                <div class="flex flex-column gap-3">
                    <div class="flex gap-3 p-3 border-round border-1 border-200 bg-blue-50">
                        <i class="pi pi-tag text-blue-600 mt-1 flex-shrink-0"></i>
                        <div>
                            <span class="font-bold text-900 block mb-1">Nombre Completo</span>
                            <span class="text-600 text-sm">El nombre descriptivo de la formulación. Ej: <i>"Grado Técnico Concentrado"</i>, <i>"Emulsión Concentrada"</i>. Se usa como referencia visual en el formulario.</span>
                        </div>
                    </div>
                    <div class="flex gap-3 p-3 border-round border-1 border-200 bg-purple-50">
                        <i class="pi pi-code text-purple-600 mt-1 flex-shrink-0"></i>
                        <div>
                            <span class="font-bold text-900 block mb-1">Abreviatura / Código <span class="text-purple-600">(impacta en el código del estudio)</span></span>
                            <span class="text-600 text-sm">Código corto de 2–4 letras. Ej: <i>"GT"</i>, <i>"EC"</i>, <i>"WP"</i>. <b class="text-900">Se incluye en el Código del Estudio asociado si no hay sufijo BPL.</b> No impacta en el Código Interno del Ítem.</span>
                        </div>
                    </div>
                    <div class="flex gap-3 p-3 border-round border-1 border-200 bg-teal-50">
                        <i class="pi pi-list text-teal-600 mt-1 flex-shrink-0"></i>
                        <div>
                            <span class="font-bold text-900 block mb-1">Clasificación</span>
                            <span class="text-600 text-sm">Categoría general: <b>"Grado Técnico / Técnico Concentrado"</b> (materias primas activas sin coadyuvantes) o <b>"Formulados"</b> (preparados listos para aplicar, mezcla de activos + formulantes). Define la lógica de cálculo del balance de masa BPL.</span>
                        </div>
                    </div>
                    <div class="flex gap-3 p-3 border-round border-1 border-200 bg-orange-50">
                        <i class="pi pi-pencil text-orange-600 mt-1 flex-shrink-0"></i>
                        <div>
                            <span class="font-bold text-900 block mb-1">Sufijo BPL <span class="text-orange-600">(impacta en el código del estudio)</span></span>
                            <span class="text-600 text-sm">Texto adicional que se anexa al <b>código del estudio asociado</b> al ítem de ensayo. Ej: <i>"IA"</i> para Ingrediente Activo o <i>"F"</i> para Formulado. Es opcional; si se deja vacío, no se agrega sufijo al estudio.</span>
                        </div>
                    </div>
                    <div class="flex gap-3 p-3 border-round border-1 border-200 bg-green-50">
                        <i class="pi pi-check-circle text-green-600 mt-1 flex-shrink-0"></i>
                        <div>
                            <span class="font-bold text-900 block mb-1">Permite Múltiples Activos</span>
                            <span class="text-600 text-sm">Si es <b>"Sí"</b>, el ítem de ensayo puede tener más de un principio activo en su composición. Si es <b>"No"</b>, el sistema solo permite un único principio activo, garantizando integridad para formulaciones simples (ej: Grado Técnico).</span>
                        </div>
                    </div>
                </div>
            </div>
        </p-popover>
    }

    <table-dynamic [config]="{
                    title: type() !== 'formulation-types' ? 'Inventario' : null,
                    columns: cols(),
                    data: data() || [],
                    totalRecords: totalRecords(),
                    first: first(),
                    showFilters: true,
                    selectable: true,
                    globalFilterFields: [],
                    loading: loading(),
                    localFilter: false,
                    showPagination: true,
                    pageSize: pageSize(),
                    lazy: true,
                    sortField: sortField(),
                    sortOrder: sortOrder(),
                    onSelectionChange: {
                        emitFullObject: true
                    }
                }" 
        [actionButtons]="actionButtons()" 
        (onDelete)="confirmDelete($event)" 
        (onDeleteAll)="confirmDeleteSelected($event)"
        (onEdit)="edit($event)" 
        (onNew)="newItem()"
        (onLazyLoad)="loadData($event)" 
        (onPageChange)="loadData($event)"
        (onDblClick)="edit($event)">
    </table-dynamic>
</div>

<modal-basic 
    *ngIf="showModal()"
    [dialog]="showModal()"
    [item]="selectedItem()"
    [fieldConfig]="fieldConfig()"
    [buttonsConfig]="buttonsConfig()"
    [title]="selectedItem()?.id ? 'Editar Registro' : 'Nuevo Registro'"
    [isLoadingButton]="loading()"
    (onHide)="hideModal()"
    (onSave)="save($event)">
</modal-basic>

